module.exports = __webpack_public_path__ + "media/images/projects/7-header-378c73c590180c35579c1b920d25a4a7.jpg";